
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { openMiniProgram } from '@xt/client/utils/mini'

@Component({
  components: {
    Qrcode,
    LazyImg
  }
})
export default class ShowQrcodePop extends Vue {
  @Prop({ required: true }) visible: boolean
  @Prop({ default: '' }) url: string
  @Prop({
    default: () => ({})
  })
  generatorParams: {
    path: string
    alias: string
  }
  @Prop({ default: 'buy' }) scanType: 'view' | 'buy'

  @Emit('closed')
  onClosed() {}

  @Emit('close')
  onClose() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}

  async handleOpenPCMini() {
    const { success, reason } = await openMiniProgram("uc", "/pages/index/index")
    console.warn(success, reason)
    if (reason) {
      this.$message.error(reason)
    }
  }
}
